export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('filter-and-search-changed').subscribe(updateHitCount);
        function updateHitCount(result) {
            ele.textContent = `${result.hits} treff`;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/liveHitCount.js